import { SubscriptionClient } from 'graphql-subscriptions-client';

export default class GraphqlWsClient extends SubscriptionClient {
  processReceivedMessage(receivedData) {
    // sent by AppSync but meaningless to us
    if (receivedData?.type === 'start_ack') {
      return;
    }

    super.processReceivedMessage(receivedData);
  }

  // eslint-disable-next-line class-methods-use-this
  checkOperationOptions(options, handler) {
    // We need to override the original method becuase AWS AppSync expect query in data as JSON stringified object
    const { data } = options;

    if (!data) {
      throw new Error('Must provide a data which needs to be JSON stringified object.');
    }
    if (!handler) {
      throw new Error('Must provide an handler.');
    }
  }
}
